<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q2fVk6/tc-custom/9781453233405.jpg?1733088297693" alt="This image is the cover for the book Murder on Their Minds, The Kent Murdock Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder on Their Minds, The Kent Murdock Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A routine assignment gets a PI killed, and Kent Murdock dives into the case</b>A thirty-eight year veteran of the Boston police force, Tom Brady has recently retired, and is beginning a new life as a private investigator. Struggling to make ends meet, he turns to newspaper photographer Kent Murdock, who recommends him to a society woman who is willing to pay big for his services. Brady’s just wrapping up the case when he asks Murdock for a favor: photographing fourteen pages of important documents for safekeeping. Murdock agrees not to look too closely while he takes the pictures—a decision he regrets when the negatives are stolen and Tom Brady is found dead. Normally Murdock stays out of the way of the Boston police, but he gave Brady the assignment. To atone, he must unravel the mystery that cost his friend his life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Harmon Coxe
      </h2>
      
      <p class="authorDescription body article">George Harmon Coxe (1901&ndash;1984) was an early star of hard-boiled crime fiction, best known for characters he created in the seminal pulp magazine <i>Black Mask</i>. Born in upstate New York, he attended Purdue and Cornell Universities before moving to the West Coast to work in newspapers. In 1922 he began publishing short stories in pulp magazines across various genres, including romance and sports. He would find his greatest success, however, writing crime fiction.&#160;In 1934 Coxe, relying on his background in journalism, created his most enduring character: Jack &ldquo;Flashgun&rdquo; Casey, a crime photographer. First appearing in &ldquo;Return Engagement,&rdquo; a <i>Black Mask </i>short, Casey found success on every platform, including radio, television, and film. Coxe&rsquo;s other well-known characters include Kent Murdock, another photographer, and Jack Fenner, a PI. Always more interested in character development than a clever plot twist, Coxe was at home in novel-writing, producing sixty-three books in his lifetime. Made a Grand Master of the Mystery Writers of America in 1964, Coxe died in 1984.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15df8ced